const SolicitationRouer = r => require.ensure([], () => r(require('@/page/SolicitationOfOpinions/indexview.vue')), 'SolicitationRouer');
const Solicitation = r => require.ensure([], () => r(require('@/page/SolicitationOfOpinions/index.vue')), 'index');
const ReplenishList = r => require.ensure([], () => r(require('@/page/SolicitationOfOpinions/page/ReplenishList.vue')), 'ReplenishList');
const add = r => require.ensure([], () => r(require('@/page/SolicitationOfOpinions/page/add.vue')), 'add');
const seeList = r => require.ensure([], () => r(require('@/page/SolicitationOfOpinions/page/seeList.vue')), 'seeList');
const SummaryList = r => require.ensure([], () => r(require('@/page/SolicitationOfOpinions/page/SummaryList.vue')), 'SummaryList');
const data = r => require.ensure([], () => r(require('@/page/SolicitationOfOpinions/page/data.vue')), 'data');


const SolicitationOfOpinionsRouer = {
  path: '',
  name: '意愿征集',
  component: SolicitationRouer,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
    keepAlive: false,
  },
  children: [
    {
      path: '/Solicitation',
      component: Solicitation,
      name: '意愿征集',
      meta: {
        right: ['意愿征集'],
        isShowMenu: true,
        keepAlive:false,
      },
    },
    {
      path: '/ReplenishList',
      component: ReplenishList,
      name: '补录',
      meta: {
        right: ['补录'],
        isShowMenu: true,
        keepAlive:false,
      },
    },
    {
      path: '/add',
      component: add,
      name: '补录录入',
      meta: {
        right: ['补录录入'],
        isShowMenu: true,
        keepAlive:false,
      },
    },
    {
      path: '/addSee',
      component: add,
      name: '补录查看',
      meta: {
        right: ['补录录入查看'],
        isShowMenu: true,
        keepAlive:false,
      },
    },
    {
      path: '/seeList',
      component: seeList,
      name: '查看意愿征集详情',
      meta: {
        right: ['查看意愿征集详情'],
        isShowMenu: true,
        keepAlive:false,
      },
    },
    {
      path: '/SummaryList',
      component: SummaryList,
      name: '查看汇总表',
      meta: {
        right: ['查看汇总表'],
        isShowMenu: true,
        keepAlive:false,
      },
    },
    {
      path: '/data',
      component: data,
      name: '小区基础数据',
      meta: {
        right: ['小区基础数据'],
        isShowMenu: true,
        keepAlive:false,
      },
    }
  ]
};
export default SolicitationOfOpinionsRouer;